class CegoXMPPTimer {

    constructor() {
        this.watches = {};
    }

    set(watch) {
        this.watches[watch] = new Date().getTime();
    };

    get(watch) {
        const diff = new Date().getTime() - this.watches[watch];
        return diff;
    };

    reset() {
        this.watches = {};
    }
}

